// Gold chart — real market data via TradingView (replaced simulated Chart.js data, 2026-07-22)
(function () {
  function init() {
    var canvas = document.getElementById('goldChart');
    if (!canvas) return;
    var wrapper = canvas.closest('.chart-canvas-wrapper') || canvas.parentElement;
    if (!wrapper) return;

    // Hide legacy period/type controls; TradingView provides its own
    ['.period-btn', '.chart-type-btn', '.chart-type-toggle'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; });
    });
    // Keep legacy inline onclick handlers from throwing
    window.changePeriod = window.changePeriod || function () {};
    window.changeChartType = window.changeChartType || function () {};

    wrapper.innerHTML = '';
    wrapper.style.height = '500px';
    var outer = document.createElement('div');
    outer.className = 'tradingview-widget-container';
    outer.style.cssText = 'height:100%;width:100%';
    var inner = document.createElement('div');
    inner.className = 'tradingview-widget-container__widget';
    inner.style.cssText = 'height:100%;width:100%';
    outer.appendChild(inner);
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    s.async = true;
    s.text = JSON.stringify({
      autosize: true,
      symbol: 'OANDA:XAUUSD',
      interval: 'D',
      timezone: 'America/New_York',
      theme: 'light',
      style: '3',
      locale: 'en',
      hide_top_toolbar: false,
      hide_legend: true,
      allow_symbol_change: false,
      save_image: false,
      calendar: false,
      withdateranges: true
    });
    outer.appendChild(s);
    wrapper.appendChild(outer);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
